module.exports = __webpack_public_path__ + "static/media/landing_1.15cc10b0.jpg";